import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { useController } from './provider';

export const BusyIndicator = () => {
    const { busy } = useController();
    return !busy ? null : (
        <Spinner animation="border" size="sm" />
    );
};
